export const iconFontAwesomeConnectivitySatelliteDish = (
	<i className="fa-solid fa-satellite-dish"></i>
);
